import React, { useEffect, useState } from 'react';
import { useAuth } from '../custom-hooks/useAuth';
import ClosedSidebar from '../components/closedSidebar';
import OpenedSidebar from '../components/openedSidebar';
import Navbar from '../components/navbar';
import { connect } from 'react-redux';
import { dashboardActions } from '../redux-utils/actions/dashboard-actions';
import Participants from './participants/participants';
import Loader from '../components/Loader';
import EmptyState from '../components/EmptyState';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const { allParticipantAction, singleParticipantAction } = dashboardActions;

function DashboardData({
    allParticipantDispatchAction,
    singleParticipantDispatchAction,
    allParticipantResult,
}) {
    const isOpened = useSelector((state) => state.sidebarState.isOpen);
    const tents = useSelector((state) => state.tentState.allTentData);
    const { getLogin } = useAuth();
    const loginStorage = JSON.parse(getLogin());
    const { t } = useTranslation();

    useEffect(() => {
        const allParam = {
            token: loginStorage && loginStorage.loginData.data.token,
        };
        allParticipantDispatchAction(allParam);
    }, []);

    const totalTents = tents.length;

    const activeParticipants = allParticipantResult.allParticipantData.length;

    if (
        allParticipantResult.allParticipantData &&
        allParticipantResult.allParticipantData.length > 0
    ) {
        return (
            <main className="h-screen font-sans flex">
                {isOpened ? <OpenedSidebar /> : <ClosedSidebar />}
                <section className="w-full bg-[#F9F9F9]">
                    <div className="flex flex-col px-20 pt-10">
                        <h1 className="text-2xl text-tertiary font-medium">
                            {t('dashboard-page.Dashboard')}
                        </h1>
                        <div className="flex items-center gap-10 mt-10">
                            <div className="flex flex-col rounded-lg shadow-md px-6 py-4 gap-2">
                                <h1 className="text-tertiary font-medium">
                                    {t('dashboard-page.Total Participants')}
                                </h1>
                                <h1 className="text-2xl text-secondary font-medium">
                                    {activeParticipants}
                                </h1>
                            </div>
                            <div className="flex flex-col rounded-lg shadow-md px-6 py-4 gap-2">
                                <h1 className="text-tertiary font-medium">
                                    {t('dashboard-page.Total Tents')}
                                </h1>
                                <h1 className="text-2xl text-secondary font-medium">
                                    {totalTents}
                                </h1>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }

    return (
        <main className="h-screen font-sans flex">
            {isOpened ? <OpenedSidebar /> : <ClosedSidebar />}
            <section className="w-full bg-[#F9F9F9]">
                {allParticipantResult.status === '' ||
                allParticipantResult.status ===
                    'all_participant_fetch_start' ? (
                    <Loader />
                ) : allParticipantResult.status ===
                      'all_participant_fetch_success' &&
                  allParticipantResult.allParticipantData &&
                  allParticipantResult.allParticipantData.length > 0 ? (
                    <section className="w-full bg-[#F9F9F9]">
                        <div className="flex flex-col px-20 pt-10">
                            <h1 className="text-2xl text-tertiary font-medium">
                                Dashboard
                            </h1>
                            <div className="flex items-center gap-10 mt-10">
                                <div className="flex-1 flex flex-col rounded-lg shadow-md px-6 py-4 gap-2">
                                    <h1 className="text-tertiary font-medium">
                                        {t('dashboard-page.Total Participants')}
                                    </h1>
                                    <h1 className="text-2xl text-secondary font-medium">
                                        {
                                            allParticipantResult
                                                .allParticipantData.length
                                        }
                                    </h1>
                                </div>
                                <div className="flex-1 flex flex-col rounded-lg shadow-md px-6 py-4 gap-2">
                                    <h1 className="text-tertiary font-medium">
                                        {t('dashboard-page.Total Tents')}
                                    </h1>
                                    <h1 className="text-2xl text-secondary font-medium">
                                        {totalTents}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <EmptyState />
                )}
            </section>
        </main>
    );
}

const areEqual = (prevProps, nextProps) => {
    // Check if the data prop is equal
    return (
        prevProps.allParticipantResult.allParticipantData ===
        nextProps.allParticipantResult.allParticipantData
    );
};

const DashboardMemo = React.memo(DashboardData, areEqual);

function Dashboard(props) {
    const {
        allParticipantDispatchAction,
        singleParticipantDispatchAction,
        allParticipantResult,
    } = props;

    const { getLogin } = useAuth();
    const loginStorage = JSON.parse(getLogin());

    useEffect(() => {
        const allParam = {
            token: loginStorage && loginStorage.loginData.data.token,
        };
        allParticipantDispatchAction(allParam);
    }, []);

    return (
        <>
            <DashboardMemo
                allParticipantDispatchAction={allParticipantDispatchAction}
                singleParticipantDispatchAction={
                    singleParticipantDispatchAction
                }
                allParticipantResult={allParticipantResult}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    allParticipantResult: state.dashboardState,
});

const mapDispatchToProps = (dispatch) => ({
    allParticipantDispatchAction: (param) =>
        dispatch(allParticipantAction(param)),
    singleParticipantDispatchAction: (param) =>
        dispatch(singleParticipantAction(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
